export async function getCountryId(countryCode, countries) {
	// @ts-ignore
	for (let i=0; i < countries.length; i++) {
		if (countries[i].iso === countryCode) {
			return countries[i].id;
		}
	}
	return null;
}
